import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Grid,
  Button,
  useTheme,
} from '@mui/material';
import {
  ArrowForward,
  BoltOutlined,
  ShieldOutlined,
  WorkspacePremiumOutlined,
  TuneOutlined,
} from '@mui/icons-material';
import ReviewsSlider from '../../components/reviews-slider/reviews-slider.component';

const REASONS = [
  {
    icon: BoltOutlined,
    title: 'Praticidade',
    text: 'Adquira o seu seguro viagem em poucos minutos, sem burocracia.',
  },
  {
    icon: ShieldOutlined,
    title: 'Segurança',
    text: 'Coberturas completas que atendem exatamente à sua necessidade.',
  },
  {
    icon: WorkspacePremiumOutlined,
    title: 'Qualidade',
    text: 'Trabalhamos apenas com as melhores seguradoras do mercado.',
  },
  {
    icon: TuneOutlined,
    title: 'Variedade',
    text: 'Opções para todos os bolsos e todos os tipos de viagem.',
  },
];

const SobreNos = () => {
  const theme = useTheme();

  return (
    <Box>
      {/* Hero */}
      <Box sx={{ backgroundColor: theme.palette.text.primary, color: 'white' }}>
        <Container maxWidth="lg" sx={{ py: { xs: 7, md: 11 }, textAlign: 'center' }}>
          <Typography variant="h1" sx={{ fontSize: { xs: '2.2rem', md: '3rem' }, mb: 2 }}>
            Uma empresa à frente do seu tempo
          </Typography>
          <Typography variant="h4" sx={{ color: theme.palette.grey[100], maxWidth: 680, mx: 'auto' }}>
            Comprar o seu seguro viagem pode ser prático e rápido. Viaje seguro e
            tranquilo com a Assegurados.
          </Typography>
        </Container>
      </Box>

      {/* Sobre + Missão */}
      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 9 } }}>
        <Grid container spacing={5}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography variant="h2" sx={{ mb: 2 }}>
              Sobre nós
            </Typography>
            <Typography variant="body1" sx={{ color: theme.palette.text.secondary, fontSize: '1.05rem' }}>
              Somos uma plataforma de cotação e compra de seguro viagem. Trabalhamos
              com as melhores seguradoras do mercado e prezamos pela praticidade e
              segurança do nosso cliente.
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography variant="h2" sx={{ mb: 2 }}>
              Nossa missão
            </Typography>
            <Typography variant="body1" sx={{ color: theme.palette.text.secondary, fontSize: '1.05rem' }}>
              Fornecer aos nossos clientes as melhores opções de seguro viagem, com
              preços justos e cobertura completa. Trabalhamos com as principais
              seguradoras do mercado, garantindo proteção em todas as etapas da
              viagem. Acreditamos que viajar deve ser uma experiência despreocupada —
              e estamos comprometidos em ajudar você a alcançar isso.
            </Typography>
          </Grid>
        </Grid>
      </Container>

      {/* Por que nós */}
      <Box sx={{ backgroundColor: theme.palette.grey[50] }}>
        <Container maxWidth="lg" sx={{ py: { xs: 6, md: 9 } }}>
          <Typography variant="h2" sx={{ mb: 1, textAlign: 'center' }}>
            Por que a Assegurados?
          </Typography>
          <Typography variant="body2" sx={{ textAlign: 'center', mb: 5 }}>
            Quatro motivos para contratar o seu seguro viagem com a gente.
          </Typography>
          <Grid container spacing={3}>
            {REASONS.map((reason) => {
              const Icon = reason.icon;
              return (
                <Grid size={{ xs: 12, sm: 6, md: 3 }} key={reason.title}>
                  <Box
                    sx={{
                      backgroundColor: 'white',
                      borderRadius: '16px',
                      p: 4,
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 1.5,
                    }}
                  >
                    <Icon sx={{ fontSize: 40, color: theme.palette.primary.main }} />
                    <Typography variant="h3" sx={{ fontSize: '1.35rem' }}>
                      {reason.title}
                    </Typography>
                    <Typography variant="body2">{reason.text}</Typography>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </Container>
      </Box>

      {/* Depoimentos */}
      <Box sx={{ backgroundColor: theme.palette.text.primary }}>
        <Container maxWidth="lg" sx={{ py: { xs: 6, md: 9 } }}>
          <ReviewsSlider />
        </Container>
      </Box>

      {/* CTA final */}
      <Box sx={{ backgroundColor: theme.palette.primary.main, color: 'white' }}>
        <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 }, textAlign: 'center' }}>
          <Typography variant="h2" sx={{ mb: 2 }}>
            Nas suas férias você merece descansar sem se preocupar!
          </Typography>
          <Typography variant="h4" sx={{ mb: 4, opacity: 0.9 }}>
            Encontre agora mesmo a opção de seguro viagem ideal para você.
          </Typography>
          <Button
            component={RouterLink}
            to="/"
            variant="contained"
            size="large"
            endIcon={<ArrowForward />}
            sx={{
              borderRadius: '999px',
              px: 5,
              py: 1.5,
              textTransform: 'none',
              fontWeight: 700,
              backgroundColor: 'white',
              color: theme.palette.primary.main,
              '&:hover': { backgroundColor: theme.palette.grey[50] },
            }}
          >
            Cotar seguro viagem
          </Button>
        </Container>
      </Box>
    </Box>
  );
};

export default SobreNos;
